export type Quote = {
    text: string,
    author: string,
    age: string,
    description: string
}

export const quotes: Quote[] = [
    {
        text:
            'En échange, on veut bien inviter ton copain \nde classe. Pardon, la classe de ton copain.',
        description: 'Papa de Lucas, 11 ans.',
        age: '42 ans',
        author: 'Pierre'
    },
    {
        text: 'Ça sera des bonbons au repas. \nEntrée, Plat, Dessert.',
        description: 'Maman de Timéo, 5 ans.',
        age: '36 ans',
        author: 'Noémie'
    },
    {
        text:
            'Avec ton père on jouera avec toi aux \n dinosaures. Oui, je ferai le diplodocus.',
        description: 'Maman de Matéo, 9 ans.',
        age: '38 ans',
        author: 'Marjorie'
    },
    {
        text:
            'Je veux bien te donner mon téléphone de \n travail. Mais tu pourras me le prêter ?',
        description: 'Papa de Matéo, 6 ans.',
        age: '44 ans',
        author: 'Julien'
    }
]
